<template>
  <div style="width: 100%;margin: auto;padding: 10px;">
    {{columns.title}}
    <!--    <el-link @click="getList" icon="el-icon-refresh">刷新</el-link>-->
    <el-table v-loading="loading"
              :data="dataList"
              :summary-method="getSummaries"
              show-summary
              header-cell-class-name="headerCell" border
    >
      <el-table-column label="序号" width="65" align="center">
        <template slot-scope="{$index}">
          <span>{{ $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作项"
          header-align="center"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <AdOptColumn :op-range="['exec','more']" :row="scope.row" :row-index="scope.$index"
                       :is-pre-executor="isPreExecutor" :pt="pt"
                       @refreshOrderList="getList"/>
        </template>
      </el-table-column>
      <el-table-column
          v-for="(v,k) in columns"
          :key="k"
          :prop="v.field?v.field:typeof(v.value)=='string'?v.value:''"
          :label="v.title"
          :min-width="v.width"
          :show-overflow-tooltip="true"
          :header-align="v.header_align?v.header_align:'left'"
          :align="v.align?v.align:'left'"
          :sortable="v.sortable?v.sortable:false">
        <template slot-scope="scope">
          <to-order-detail v-if="v.field==='order_no'" :pt="pt" :order="scope.row" :is-pre-executor="isPreExecutor" />
          <template v-else>
            <span v-if="typeof(v.value)=='string'">
              <span v-if="v.type == 'image'">
                <img :src="scope.row[v.value]" :alt="scope.row[v.value]" width="40px">
              </span>
              <span v-else-if="v.value_alias">
                <el-tooltip effect="dark" :content="scope.row[v.value_alias]" placement="top-start"
                            popper-class="ape-table-tooltip" v-if="scope.row[v.value]">
                  <span v-html="scope.row[v.value]"></span>
                </el-tooltip>
                 <span v-else v-html="scope.row[v.value_alias]"></span>
              </span>
              <span v-else v-html="scope.row[v.value]"></span>
            </span>
            <span v-else-if="typeof(v.value)=='object'">
              <span v-for="(v1,k1) in v.value" :key="k1">
                <template v-if="v.key">
                  <template v-for="(item, idx) in scope.row[v.key]">
                    <el-tooltip :key="idx" effect="dark" placement="top-start">
                      <div slot="content" v-html="item[v1.value_alias]"></div>
                      <p class="is-value">{{ item[v1.value] }}</p>
                    </el-tooltip>
                  </template>
                </template>
                <span class="more-info-display"
                      v-else-if="scope.row[v1.value] || scope.row[v1.value_alias] || scope.row[v1]">
                  <span class="is-value" v-if="typeof(v1)=='string'" v-html="scope.row[v1]"></span>
                  <span class="is-label" v-if="typeof(v1)=='object' && v1.label"
                        :style="{width:v1.width?parseInt(v1.width)+'px':'72px'}" v-html="v1.label"></span>
                  <template v-if="v1.value_alias && v1.value">
                    <el-tooltip effect="dark" placement="top-start" popper-class="ape-table-tooltip"
                                v-if="scope.row[v1.value]">
                      <div slot="content" v-html="scope.row[v1.value_alias]"></div>
                      <span class="is-value" v-if="typeof(v1)=='object'" v-html="scope.row[v1.value]"></span>
                    </el-tooltip>
                    <span class="is-value" v-else v-html="scope.row[v1.value_alias]"></span>
                  </template>
                  <template v-else>
                    <span class="is-value" v-if="typeof(v1)=='object'" v-html="scope.row[v1.value]"></span>
                  </template>
                </span>
              </span>
            </span>
          </template>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import AdOptColumn from "@/views/adOrder/components/AdOptColumn";
import {getTableCols} from "@/api/cache";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";
import {getPukeOrderChild} from "@/api/regulars";

export default {
  name: "ChildOrderTable",
  components: {AdOptColumn, ToOrderDetail},
  props: {
    pid: {
      type: [Number, String]
    },
    isPreExecutor: {
      type: Number,
      default() {
        return 0
      }
    },
    pt: Number,
  },
  data() {
    return {
      loading: false,
      dataList: [],
      payStatusOptions: [
        {label: '已完结', value: 2},
        {label: '部分回款', value: 1},
        {label: '待回款', value: 0},
      ],
      invoiceStatusOptions: [
        {label: '未开票', value: 'none'},
        {label: '部分开票', value: 'part'},
        {label: '全部开票', value: 'done'},
      ],
      columnsFixed: ['customer_name'],//固定字段
      columnsExclude: [],//循环排除，特定样式
      columns: [],
      calcFields: ['payment_account', 'adv_revenue', 'sum_amount', 'artist_income', 'company_income', 'exec_price', 'authorized_price', 'cart_charges', 'cart_commission', 'other_fee', 'rebates_amount', 'remain_account'],
    }
  },
  methods: {
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index < 1) {
          return
        }
        if (index === 1) {
          sums[index] = '汇总:'
          return
        }
        if (this.calcFields.indexOf(column.property) > -1) {
          const values = data.map(item => {
            if (item.bool_undo) {
              return 0
            }
            return Number(item[column.property])
          })
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          // 格式化数据
          sums[index] = this.moneyFormat(sums[index])

          // switch (column.property) {
          //   case 'exec_price':
          //   case 'authorized_price':
          //   case 'company_income':
          //   case 'artist_income':
          //   case 'sum_amount':
          //   case 'payment_account':
          //   case 'adv_revenue':
          //   case 'cart_charges':
          //   case 'cart_commission':
          //     sums[index] = this.moneyFormat(sums[index])
          //     break
          //   default:
          //     break
          // }
        }
      })

      return sums
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2, ',')
    },
    //表头
    async getTableThead() {
      this.columns = [];
      //读取缓存列
      let cacheColumns = localStorage.getItem('ad-columns')
      if (cacheColumns) {
        this.columns = JSON.parse(cacheColumns);
      }
      let {tableCols} = await getTableCols({type: 'ad_order', sort: true}).then((res) => {
        return res.model
      })
      let currentColumns = [];
      tableCols.forEach((item) => {
        //要显示并且不是固定字段 item.display &&
        if (item.display) {
          if (this.columnsExclude.indexOf(item.name) === -1) {
            currentColumns.push({
              title: item.title,
              value: item.name,
              width: item.min_width || 120,
              header_align: item.header_align || 'center',
              align: item.align || 'center',
              sortable: item.sortable || false,
              field: item.field || item.name,
            })
          }
        }
      })

      this.columns = currentColumns;
      localStorage.setItem('ad-columns', JSON.stringify(currentColumns))
      // this.$emit('tableColumns', this.columns)

    },

    invoiceStatusFormat(val) {
      let item = this.invoiceStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    payStatusFormat(val) {
      let item = this.payStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    execStatusFormat(val) {
      return val === 1 ? '已执行' : '未执行';
    },
    async getList() {
      this.loading = true
      this.dataList = []
      let {data} = await getPukeOrderChild({pid:this.pid}).then(res => {
        return res.model
      })
      this.loading = false
      this.dataList = data || []
      // this.$nextTick(() => {
      //
      // })

    },
  },
  created() {
    this.getTableThead()
    this.getList()
  }
}
</script>

<style>
.wcn-tbl {
    color: #00c297;
}

.headerCell .cell {
    /*background-color: #000000!important;*/
    background-color: #ff3176 !important;
    color: #FFFFFF !important;
}
</style>
